export const required = { message: "Field is required", value: true };

// This is not up to RFC822, but this doesn't need to be thorough
export const emailRegex = /.+@.+\..+/g;

export const COLOUR_NAME = {
  red: "R",
  green: "G",
  blue: "B",
  grey: "Gy",
  magenta: "M",
  yellow: "Y",
  cyan: "C",
};
